import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";

// Styled components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import Select from "react-select";

// Utils
import {
  ercoLogo,
  epmLogo,
  adviserPhoto,
  epmAdviserPhoto,
  getDate,
  selectStyles,
  panama,
  getFormattedDate
} from "../utils/handlers/handlers";
import { fetchAdviserData, fetchQuoteVersions } from "../utils/redux";
import config from "../config/config.json";

function Home({
  cliente,
  currentVersion,
  fecha_expiracion,
  fetchAdviserData,
  adviser,
  id,
  fetchQuoteVersions,
  quoteVersions,
  designer,
  city,
  isEpm,
  defaultAdviserPhoto
}) {
  useEffect(() => {
    if (id && currentVersion) {
      fetchAdviserData(id, currentVersion);
      fetchQuoteVersions(id);
    }
  }, [fetchAdviserData, fetchQuoteVersions, id, currentVersion]);

  const [versions, setVersions] = useState([]);
  const [countryCode] = useState(city.includes("panama") ? 507 : 57);
  const source = useSelector((state) => state.globalData.data);

  const quoteDate = getFormattedDate(source.createdAt)

  useEffect(() => {
    if (quoteVersions) {
      setVersions(quoteVersions);
    }
  }, [quoteVersions]);

  const getNewQuote = (requestedVersion) => {
    if (requestedVersion !== currentVersion) {
      const baseUrl = `${config.url}/${id}/${requestedVersion}`;
      window.location.href = baseUrl;
    }
  };

  return (
    <section
      id="home"
      className="home flex w-screen flex-col h-screen align-center justify-center"
    >
      <div className="h-auto mt-20  ml-2 lg:ml-32 text-font-greyLight z-10">
        <div className="container ml-2 mt-4 lg:mt-6 lg:mb-4 w-auto ">
          <h1 className="font-bold lg:text-left text-2xl lg:text-4xl">
            Hola, {cliente}
          </h1>
          {
            !isEpm && (
              <>
                <h2 className="text-xl font-semibold lg:text-3xl mt-8">
                  Con el Ecosistema de{" "}
                  <span className="text-font-green">Energía Erco</span>,
                </h2>
                <h2 className="text-xl font-semibold lg:text-3xl">
                  Tienes el control de tu{" "}
                  <span className="text-font-yellow">Energía</span>
                </h2>
              </>
            )
          }
          <br />
          <p className="text-lg lg:text-xl">
            Fecha de creación de la propuesta: {quoteDate}
            <br />
            Esta propuesta económica ha expirado el día{" "}
            {getDate(fecha_expiracion)}.
          </p>
          <br />
          <p className="text-lg lg:text-xl">
            Puedes revisar otras versiones disponibles:
          </p>
          {versions.length > 0 ? (
            <div className="flex flex-row items-center">
              <p className="text-lg lg:text-xl mr-4 lg:mr-8">Versión: </p>
              <Select
                className="w-20 lg:w-24"
                isDisabled={false}
                isLoading={false}
                isClearable={false}
                isRtl={false}
                isSearchable={false}
                name="versions"
                options={versions}
                onChange={(option) => getNewQuote(option.value)}
                placeholder={currentVersion}
                styles={selectStyles}
              />
            </div>
          ) : (
            <p>Versión {currentVersion}</p>
          )}
        </div>
        <div className="mt-3">
          <p className="text-lg lg:text-xl mb-3">
            O ponerte en contacto con tu asesor:
          </p>
          <div className="flex space-x-2 items-center lg:space-x-6">
            <div className="text-center ml-2 lg:ml-0 text-lg">
              <img
                className="w-24 h-24 rounded-full"
                src={adviser.imagen ? adviser.imagen : defaultAdviserPhoto}
                alt="Asesor"
              />
              <h6>Asesor</h6>
            </div>
            {!adviser.nombre ? (
              <div className="text-sm md:text-lg animate-pulse">
                <p>
                  <span className="bg-gray-300 h-3 w-48 inline-block rounded-full"></span>
                  <span className="block bg-gray-300 h-3 w-32 mt-1 rounded-full"></span>
                </p>
                <p>
                  <span className="bg-gray-300 h-3 w-6 rounded-full"></span>
                  <span className="ml-2 lg:ml-3 bg-gray-300 h-3 w-32 inline-block rounded-full"></span>
                </p>
                <p>
                  <span className="bg-gray-300 h-3 w-6 rounded-full"></span>
                  <span className="ml-2 bg-gray-300 h-3 w-20 inline-block rounded-full"></span>
                </p>
              </div>
            ) : (
              <div className="text-sm md:text-lg">
                <p>
                  {adviser.nombre}
                  <span className="block">{adviser.cargo}</span>
                </p>
                <p>
                  <a
                    href={`mailto:${adviser.email}?subject=Duda sobre cotización`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      color="#92BD21"
                      size="xl"
                    />
                  </a>
                  <span className="ml-2 lg:ml-3">{adviser.email}</span>
                </p>
                <p>
                  <a
                    href={`https://wa.me/${countryCode}${adviser.wapp}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      color="#92BD21"
                      size="lg"
                    />
                  </a>
                  <span className="ml-2">{adviser.wapp}</span>
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="grid w-screen bottom-0 invisible lg:visible">
          <img
            className="justify-self-center bottom-8 absolute h-10 lg:h-16 z-10"
            src={isEpm ? epmLogo : ercoLogo}
            alt="Logo"
          />
          <svg
            className="absolute right-0 bottom-0 z-0 text-9xl"
            width="530"
            height="620"
            viewBox="0 0 119 139"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M57.2848 138.208C55.6698 137.591 53.4246 135.161 52.5703 133.422L51.8606 131.976L51.7065 118.133C51.5623 105.182 51.5166 104.127 50.9985 101.75C49.2957 93.9415 46.0426 87.6196 40.8179 81.9658C36.8432 77.6647 34.6972 74.6496 32.5179 70.3042C30.0027 65.2889 28.5192 60.6859 27.7054 55.3722C27.1641 51.8372 27.1679 44.9437 27.7134 41.4253C30.5366 23.2082 42.9821 8.35623 60.2671 2.57707C66.1685 0.603976 67.456 0.421048 75.4828 0.415299C81.9635 0.410699 82.8316 0.461892 85.2618 0.992455C98.5381 3.89086 109.534 11.5871 116.664 22.9713L118.279 25.5503L118.282 48.3062L118.285 71.0622L117.014 73.177C115.342 75.9589 113.576 78.2816 110.564 81.662C105.178 87.7059 102.03 93.661 100.215 101.242C99.7004 103.389 99.6572 104.381 99.5073 117.498C99.36 130.393 99.3109 131.556 98.8693 132.611C97.8182 135.123 95.7164 137.22 93.5265 137.943L92.6992 138.216C57.1903 137.83 93.621 138.321 57.2848 138.208V138.208ZM91.7114 132.226C93.3715 131.438 93.3896 131.325 93.3896 121.714V113.053H75.6096H57.8296V121.887C57.8296 129.637 57.8803 130.793 58.2432 131.311C59.1394 132.59 59.145 132.591 75.5712 132.601C88.7573 132.61 91.0132 132.557 91.7114 132.226ZM64.9416 88.5755V70.1938L62.3381 70.0749C60.2132 69.9778 59.4772 69.8335 58.3344 69.2897C56.5351 68.4335 54.9598 66.8644 54.0987 65.0707C53.5204 63.8658 53.4144 63.3025 53.4007 61.3592C53.386 59.2648 53.4563 58.9224 54.2208 57.3694C55.7319 54.2993 58.0818 52.8328 61.7666 52.6602C64.6681 52.5242 66.3604 53.0954 68.2133 54.8361C70.0832 56.5928 70.8348 58.4104 70.9855 61.5401L71.1055 64.0313H75.4796H79.8537L79.993 61.5045C80.1597 58.4791 80.8332 56.7619 82.5108 55.0853C84.3185 53.2786 85.7163 52.7361 88.5636 52.7361C91.4109 52.7361 92.8087 53.2786 94.6163 55.0853C96.3201 56.7881 97.0447 58.6177 97.0526 61.2373C97.0586 63.0849 96.9537 63.6267 96.328 64.9943C94.8305 68.2669 91.7305 70.1273 87.7748 70.1273H86.0236V88.5423V106.957H89.691H93.3585L93.5116 105.751C94.2658 99.8072 95.266 95.8336 97.072 91.6055C99.5435 85.819 101.423 83.0513 108.091 75.3819C111.218 71.785 114.225 66.3314 115.821 61.3643C117.412 56.4119 117.647 54.6993 117.639 48.1563C117.632 42.6576 117.59 42.1351 116.917 39.2663C114.681 29.7272 109.578 21.4494 102.362 15.6572C96.6031 11.0341 91.0676 8.38611 83.9063 6.82845C80.3735 6.06002 71.3942 5.99405 67.8626 6.71058C54.5601 9.40956 43.5832 17.8191 37.6351 29.8683C34.3718 36.4788 33.3301 41.0125 33.3458 48.5373C33.3548 52.8973 33.4367 53.8735 34.0297 56.6911C35.204 62.2714 37.0344 66.7681 39.9438 71.2202C41.5307 73.6484 42.6858 75.0887 46.8082 79.7793C52.6176 86.3893 56.6506 95.9269 57.4681 104.989L57.6457 106.957H61.2936H64.9416V88.5755ZM105.013 50.9336C104.136 50.4576 103.55 49.34 103.55 48.1435C103.55 47.4279 103.747 47.0195 104.413 46.3529C105.15 45.6157 105.452 45.4893 106.471 45.4893C107.49 45.4893 107.791 45.6157 108.528 46.3529C109.247 47.0719 109.392 47.4025 109.392 48.3283C109.392 49.5979 108.922 50.4051 107.865 50.9517C106.944 51.4278 105.912 51.4212 105.013 50.9336V50.9336ZM102.602 39.2605C102.299 39.0478 101.343 37.5059 100.479 35.8342C95.6876 26.5639 87.1988 20.9884 77.0066 20.4172C74.1718 20.2584 73.2588 19.9219 72.6929 18.8276C71.6584 16.827 72.6559 14.7915 74.8739 14.377C76.146 14.1393 80.97 14.688 83.7567 15.3873C93.2864 17.7788 101.525 24.3937 105.906 33.1703C107.569 36.502 107.581 37.8211 105.959 39.0966C105.124 39.7538 103.425 39.8367 102.602 39.2605H102.602ZM79.9276 88.5423V70.1273H75.4826H71.0376V88.5423V106.957H75.4826H79.9276V88.5423ZM64.9416 62.0339C64.9416 60.2269 64.8793 59.9742 64.2881 59.383C63.0933 58.1882 61.2019 58.1882 60.0071 59.383C59.4815 59.9087 59.3536 60.282 59.3536 61.2914C59.3536 62.3398 59.4758 62.6686 60.0961 63.2888C60.7941 63.9869 60.9612 64.0313 62.8901 64.0313H64.9416V62.0339ZM90.3611 63.2888C91.4124 62.2376 91.4151 60.5779 90.3671 59.4055C89.7581 58.7239 89.447 58.5818 88.5631 58.5818C87.6793 58.5818 87.3682 58.7239 86.7592 59.4055C86.0861 60.1588 86.0231 60.3918 86.0231 62.1303V64.0313H87.8207C89.4688 64.0313 89.68 63.9696 90.3607 63.2888H90.3611ZM14.9649 82.4906C13.7242 81.8016 13.1761 80.2328 13.73 78.9559C14.1782 77.9225 20.1157 72.0234 21.063 71.6703C22.058 71.2993 23.1975 71.6022 24.0629 72.4676C24.6952 73.1 24.8096 73.414 24.8096 74.5183V75.8222L21.3071 79.3247C17.8424 82.7894 17.7923 82.8272 16.6716 82.8183C16.0484 82.8133 15.2804 82.6659 14.9649 82.4906ZM1.80234 50.8523C0.186161 49.8668 -0.000618994 47.4835 1.43677 46.1878L2.2116 45.4893H7.25333C11.8815 45.4893 12.3472 45.5303 12.93 45.9886C14.4465 47.1815 14.47 49.2433 12.9819 50.5499L12.0919 51.3313L7.33823 51.3303C3.13557 51.3295 2.4939 51.2741 1.80233 50.8523L1.80234 50.8523ZM20.6186 24.877C20.3392 24.7248 18.7077 23.2138 16.993 21.5193C13.4265 17.9946 13.0068 17.2096 13.8103 15.5659C14.4127 14.3334 15.7488 13.603 16.9789 13.8338C17.706 13.9702 18.5305 14.652 21.1127 17.2518C22.8867 19.0381 24.4425 20.6644 24.57 20.8659C24.6975 21.0674 24.8036 21.7295 24.8057 22.3372C24.8087 23.2578 24.6655 23.5861 23.946 24.3057C23.2579 24.9937 22.8836 25.1677 22.1045 25.1615C21.5666 25.1573 20.898 25.0293 20.6186 24.877V24.877Z"
              fill="#F2F2F2"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state) => {
  const source = state.globalData.data;
  const defaultAdviserPhoto = source.cotizacion.isEpm ? epmAdviserPhoto : adviserPhoto;
  return {
    cliente: source.cliente.nombre,
    currentVersion: source.version,
    fecha_expiracion: source.cotizacion.fecha_expiracion,
    adviser: state.adviserData.data,
    id: state.globalData.data._idCliente,
    quoteVersions: state.versionsData.data.versions,
    designer: source.designer,
    city: state.globalData.data.cotizacion.ciudad,
    isEpm: source.cotizacion.isEpm,
    defaultAdviserPhoto
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAdviserData: () => dispatch(fetchAdviserData()),
    fetchQuoteVersions: () => dispatch(fetchQuoteVersions())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
